import { Visit } from "@graphql";
import { format } from "date-fns";
import React, { useEffect } from "react";
import "./UpcomingsVisitors.css";

interface Props {
  visitors: Visit[];
}

const UpcomingsVisitors: React.FunctionComponent<Props> = (props: Props) => {
  const { visitors } = props;

  return (
    <>
      {visitors?.length > 0 && (
        <>
          <div className="title">Upcoming's Visitors</div>
          {visitors?.map((el) => (
            <div className="visitor-card" key={el._id}>
              <div className="visitors-name">
                {el.visitor?.firstName} {el.visitor?.lastName}
                <div className="company-name">{el.visitor?.company}</div>
              </div>
              <div className="future-status">
                <div className="calendar">
                  <div className="date">{format(new Date(el.expectedDate), "d")}</div>
                  <div className="month">{format(new Date(el.expectedDate), "MMM").toUpperCase()}</div>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default UpcomingsVisitors;
